import React from "react";
import { BrowserRouter } from "react-router-dom";
import { useAuthentication } from "../hooks/useAuth";

import App from "./app.routes";
import Auth from "./auth.routes";

const Routes = () => {
  const { logged } = useAuthentication();
  return <BrowserRouter basename="/infarmapix">{logged ? <App /> : <Auth />}</BrowserRouter>;
};

export default Routes;
